export default {
	AUTH_COOKIE_KEY: "service-ticket",
	AUTH_USER_NAME_KEY: "username",
	AUTH_USER_EMAIL_KEY: "useremail",
	API_SUCCESS_CODE: 0,
	API_ERROR_CODE: -1,
	API_NOT_LOGIN_CODE: 230001,
	NO_PERMISSION_CODE: 41000,
	UX_RET_CODE: 1,
	CONFIG_ERROR: "配置出错，请配置微信认证地址~或联系有关开发人员~",
	WECHATAUTH_ERROR: "抱歉，您未通过认证~请通过企业微信打开此应用",
	PARAMS_ERROR: "HTTP请求出错，请检查参数或请求方式~",
	HTTPRES_ERROR: "HTTP请求响应出错~",
	RENDER_ERROR: "找不到页面~",
	UCLOUD_EMAIL_SUFFIX: "@ucloud.cn",
	ENV_DEV: "development",

	DATE_FORMAT: "YYYY-MM-DD",
	DATETIME_FORMAT: "YYYY-MM-DD HH:mm:ss",
	MONTHTIME_FORMAT: "MM-DD HH:mm",
	DATE_MONTH_FORMAT: "MM/DD HH:mm",

	COMPONENT_TIME: "time_picker",
	COMPONENT_DATE: "date_picker",

	TAB_PENDING_TICKETS: "pendingTickets",
	TAB_SEND_TICKETS: "sendTickets",
	TAB_RECEIVED_TICKETS: "receivedTickets",
	TAB_ALL_TICKETS: "allTickets",

	UBU_TAB_ROUTER_MAP: {
		"/pending": "pendingTickets",
		"/sending": "sendTickets",
		"/receiving": "receivedTickets",
		"/all": "allTickets"
	},

	USER_ROLE_ADMIN: "admin",
	USER_ROLE_SUPPORT: "support",

	DEFAULT_PAGE_SIZE: 20,
	DEFAULT_PAGE_FIRST_PAGE: 0,

	// 工单来源：控制台
	TICKET_SOURCE_CONSOLE: 5,

	TICKET_CUSTOMER: 1,
	TICKET_BATCH_FAULT: 2,
	TICKET_ISSUE: 3,

	// 故障类型，供关联故障接口使用
	FAULT_TYPE_DEFAULT: 0, // 默认值
	FAULT_TYPE_NOC: 1, // NOC类型
	FAULT_TYPE_API: 2, // API错误日志类型
	FAULT_TYPE_ALTERATION: 3, // 变更类型
	FAULT_TYPE_MOVE: 4, // 迁移类型

	// 工单待办事项、处理进展等类型供接口使用
	TICKET_RECORD_CUSTOMER_TODO: "UBU_TICKET_TODOLIST", // 客户工单待办事项
	TICKET_RECORD_BATCH_TODO: "UBU_BATCH_TODOLIST", // 批次性故障工单待办事项
	TICKET_RECORD_ISSUE_TODO: "UBU_ISSUE_TODOLIST", // 问题工单待办事项
	TICKET_RECORD_NOC_PROGRESS: "NOC_TICKET_PROGRESS", // 事件系统处理进展
	TICKET_RECORD_NOC_FAULT_LOC: "NOC_TICKET_FAULT_LOC", // 事件系统故障定位

	FAULT_TYPE_MAP: {
		1: "告警",
		2: "API",
		3: "变更",
		4: "迁移"
	},

	NO_REALTED_FAULT_ID: "0",
	NO_REALTED_FAULT_TITLE: "无关联故障",

	NO_REALTED_FAULT_TEMP_ID: "-1",
	NO_REALTED_FAULT_TEMP_TITLE: "暂不关联故障",

	HAS_REALTED_FAULT_DEFAULT: 0,
	HAS_NO_REALTED_FAULT: 1,
	HAS_REALTED_FAULT: 2,

	TICKET_STATUS_ARR: [1, 2, 3, 4, -1, -2, -4, -5, -6],
	TICKET_STATUS: {
		PROCESSING: 1, // "处理中"
		COMPLETED: 2, // "已完成"
		NEW: 3, // "新工单"
		CLOSED: 4, // "终止"
		TRANSFERING: -1, // "转单中"
		PENDING: -2, // "挂起中"
		FEEDBACK: -4, // "待反馈"
		COMFIRMED: -5, // "已确认"
		REJECTED: -6 // "已驳回"
	},
	TICKET_STATUS_MAP: [
		{ value: 1, name: "处理中" },
		{ value: -1, name: "转单中" },
		{ value: 3, name: "新工单" },
		{ value: -6, name: "已驳回" },
		{ value: -2, name: "挂起中" },
		{ value: -5, name: "已确认" },
		{ value: -4, name: "待反馈" },
		{ value: 2, name: "已完成" }
	],

	BATCH_FAULT_TICKET_STATUS: {
		1: "处理中",
		2: "处理完成",
		4: "终止",
		[-1]: "转单中",
		[-2]: "挂起中"
	},
	BATCH_FAULT_TICKET_STATUS_MAP: {
		PROCESSING: 1, // "处理中"
		COMPLETED: 2, // "处理完成"
		CLOSED: 4, // "终止"
		TRANSFERING: -1, // "转单中"
		PENDING: -2 // "挂起中"
	},

	ISSUE_TICKET_STATUS: {
		1: "处理中",
		2: "处理完成",
		4: "终止",
		[-1]: "转单中"
	},

	ISSUE_TICKET_STATUS_MAP: {
		PROCESSING: 1, // "处理中"
		COMPLETED: 2, // "处理完成"
		CLOSED: 4, // "终止"
		TRANSFERING: -1 // "转单中"
	},

	TODO_STATUS_MAP: { 0: "默认", 1: "已删除", 2: "进行中", 3: "已完成", 4: "取消" },

	TICKET_TYPE_EXCEPTION: [2, 4], // 工单类型——异常类A和异常类B

	TIME_RANGE_MAP: {
		1: "1天",
		3: "3天",
		7: "1周",
		30: "1个月",
		90: "3个月"
	},

	FAULT_TAGS_BU_WATCHED: 7,
	FAULT_TAGS_SPT_WATCHED: 8,
	FAULT_TAGS_WATCHED: [7, 8],

	HAS_NO_INFLUENCE: 2,

	INFLUENCE_RANGE_MAP: {
		1: "有影响",
		2: "无影响",
		3: "已恢复"
	},

	CAN_FAST_RESTORE_MAP: {
		1: "可以快速恢复",
		2: "不可以快速恢复"
	},

	initialFilter: {
		create_time: "24",
		ticket_type: ["0", "2"],
		ticket_status: ["1", "3", "-6", "-4", "-2", "-1"]
	},

	filtersCreateTime: {
		"1": "1小时",
		"6": "6小时",
		"24": "1天",
		"48": "2天",
		"72": "3天"
	},

	VIPLevel: {
		K: "K",
		S: "S",
		A: "A",
		B: "B",
		C: "C"
	},

	TicketSourceType: {},
	TicketStatus: {},
	TicketType: {},
	SolveWay: {},
	GroupType: {},
	BU: {},
	FaultTags: {},
	Users: {},
	UserInfo: {},
	ChannelInfo: [],
	ResourceTypeMap: {
		0: "宿主机",
		1: "云主机",
		6: "云数据库",
		10: "云网络",
		11: "负载均衡",
		12: "UMEM",
		38: "Redis"
	},
	FAULT_TAGS_OPTIONS: {
		2: "数据丢失",
		1: "核心业务不可用",
		6: "公关风险",
		3: "客户投诉",
		4: "客户着急",
		5: "客户抱怨",
		7: "BU重点关注",
		8: "SPT关注",
		9: "批次故障"
	},
	ROLE_NAME_HANDLER: {},
	ROLE_NAME_LEADER: {},
	EVENT_STEP_STATUS: {
		0: "wait",
		1: "process",
		2: "process",
		3: "finish",
		4: "finish"
	},
  // 扣费类型
  DeductNumberType: {
    1: '实时扣费',
    2: '后付费',
    // 3: '预充值',
  }
};

export const UpgradeStatue = {
  Enable: '已升级',
  Disable: '未升级',
};

export const UpgradeStatueMap = {
  Enable: 'Enable',
  Disable: 'Disable',
};

export const salespersonAndManager = [
	"valeska.xue@ucloud.cn", 
	"qiaoling.wang@ucloud.cn",
	"jaron.jiang@ucloud.cn"
]